import { Component, HostListener, ViewChild, ElementRef, OnInit, Input } from '@angular/core';
import { WalletSummaryService } from '../../services/api/wallet-summary.service';
import { WalletSummary } from '../../models/wallet-summary.interface';
import { Router } from '@angular/router';
import { SessionService } from '../../services/session.service';

@Component({
  selector: 'app-redeem-card',
  templateUrl: './redeem-card.component.html',
  styleUrls: ['./redeem-card.component.scss']
})
export class RedeemCardComponent implements OnInit {
  walletSummary: WalletSummary | null = null;
  @Input() isLoading: boolean = false;

  autoPay:number = 0;
  autoRedeem: boolean = false;
  autoTransfer = false;
  cashEligible = false;
  rewardEligible = false;
  defaultPayment = false;
  tooltipMessage = '';
  isZelleAccount:boolean=false;
  primaryAutoPayCard: any = null;   // holds card info for PPI Auto Pay


  isPPI: boolean = false; // Flag to store if the current user is from the PPI context
  isBilliant: boolean = false;  // Flag to store if the current user is ONL/Billiant user

  monthlyRewardsAndCash: string | null = null; // For combined display for PPI
  totalRewards: number | string = 0;  // Total rewards for PPI
  totalCash: number | string = 0;  // Total cash for PPI
  cashEarnedThisMonth: number | string = 0;
  rewardsEarnedThisMonth: number | string = 0;

  @ViewChild('tooltipRewards') tooltipRewardsElement: ElementRef;
  @ViewChild('tooltipBank') tooltipBankElement: ElementRef;
  @ViewChild('tooltipAutoRedeem') tooltipAutoRedeemElement: ElementRef;
  @ViewChild('tooltipAutoTransfer') tooltipAutoTransferElement!: ElementRef; // Ensure this is declared if used in HTML

  tooltipVisibleForRewards: boolean;
  tooltipVisibleForBank: boolean;
  tooltipVisibleForAutoRedeem: boolean;
  tooltipVisibleForAutoPay: boolean;
  tooltipVisibleForAutoTransfer: boolean = false;


  ngAfterViewInit() {
     if (this.tooltipRewardsElement || this.tooltipBankElement || this.tooltipAutoRedeemElement || this.tooltipAutoTransferElement) {
      this.positionTooltips();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.positionTooltips();
  }

  constructor(private walletSummaryService: WalletSummaryService,
              private router: Router,
              private sessionService: SessionService
  ) {}

  showMenu = false;

  toggleMenu() {
    this.showMenu = !this.showMenu;
  }

  closeMenu() {
    this.showMenu = false;
  }

  onMenuClosed() {
    this.hideTooltip();
  }

  onLinkClicked(event: MouseEvent) {
    event.preventDefault();
    // Handle link click logic here
    this.closeMenu();
  }

  showTooltip(event: MouseEvent, tooltipType: 'rewards' | 'autoRedeem' | 'autoPay' | 'banks' | 'autoTransfer'): void {
    event.stopPropagation();
if (this.cashEligible && !this.rewardEligible) {
        this.tooltipVisibleForRewards = tooltipType === 'rewards';
        this.tooltipVisibleForAutoRedeem = tooltipType === 'autoRedeem';
        this.tooltipVisibleForAutoPay = tooltipType === 'autoPay';
        this.tooltipVisibleForBank = tooltipType === 'banks';
        this.tooltipVisibleForAutoTransfer = tooltipType === 'autoTransfer';
}
}

hideTooltip(event?: MouseEvent): void {
  if (event) {
      event.stopPropagation();
  }
  this.tooltipVisibleForRewards = false;
  this.tooltipVisibleForAutoRedeem = false;
  this.tooltipVisibleForAutoPay = false;
  this.tooltipVisibleForBank = false;
  this.tooltipVisibleForAutoTransfer = false;
}


  handleClick(event: MouseEvent) {
    event.preventDefault(); // Prevent default behavior (if any)
    this.hideTooltip();
  }

  @HostListener('window:scroll', ['$event'])
onScroll(event: Event) {
  this.hideTooltip();
}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;
    const isInsideMenu = targetElement.closest('.redeem-menu');
    const isInsideTooltip = targetElement.closest('.tooltip');

    if (!isInsideMenu && !isInsideTooltip) {
      this.hideTooltip();
    }
  }


positionTooltips() {
  // Add null checks for elements before positioning
  if (this.tooltipRewardsElement) {
    this.positionTooltip(this.tooltipRewardsElement, 'left');
  }
  if (this.tooltipBankElement) {
    this.positionTooltip(this.tooltipBankElement, 'center');
  }
  if (this.tooltipAutoRedeemElement) {
    this.positionTooltip(this.tooltipAutoRedeemElement, 'right');
  }
  if (this.tooltipAutoTransferElement) { // Position for auto-transfer tooltip
    this.positionTooltip(this.tooltipAutoTransferElement, 'right');
  }
}

positionTooltip(tooltipElement: ElementRef, alignment: 'left' | 'center' | 'right') {
  if (tooltipElement && tooltipElement.nativeElement) {
    const tooltip = tooltipElement.nativeElement;
    const button = tooltip.previousElementSibling;
    const buttonRect = button.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();

    // Position tooltip above the button
    tooltip.style.top = `${buttonRect.top - tooltipRect.height - 20}px`;

    switch (alignment) {
      case 'left':
        let leftPosition = buttonRect.left;
        leftPosition = Math.max(20, leftPosition);
        leftPosition = Math.min(leftPosition, window.innerWidth - tooltipRect.width - 20);
        tooltip.style.left = `${leftPosition}px`;
        tooltip.style.right = 'auto';
        break;
      case 'center':
        let centerPosition = buttonRect.left + (buttonRect.width / 2) - (tooltipRect.width / 2);
        centerPosition = Math.max(20, centerPosition);
        centerPosition = Math.min(centerPosition, window.innerWidth - tooltipRect.width - 20);
        tooltip.style.left = `${centerPosition}px`;
        tooltip.style.right = 'auto';
        break;
      case 'right':
        let rightPosition = window.innerWidth - buttonRect.right;
        rightPosition = Math.max(20, rightPosition);
        rightPosition = Math.min(rightPosition, window.innerWidth - tooltipRect.width - 20);
        tooltip.style.right = `${rightPosition}px`;
        tooltip.style.left = 'auto';
        break;
    }
  }
}

  ngOnInit(): void {
    this.isPPI = this.sessionService.isPPI(); // Set isPPI flag on init
    this.walletSummaryService.walletSummary$.subscribe(summary => {
      this.walletSummary = summary;
      this.autoPay = Number(this.walletSummary?.wallet.isDWAutoPay) || 0;
      this.autoTransfer = summary?.wallet?.autotransfer?.isDWAutoTransfer.toLowerCase() === "true";

    //  this.autoTransfer = summary?.wallet?.autotransfer?.isDWAutoTransfer === "True";
      this.isZelleAccount = summary?.wallet?.autotransfer?.bankName.toLowerCase()=="zelle"?true:false;
   //   this.autoTransfer = summary?.wallet?.isDWAutoTransfer === "True";
      this.cashEligible = summary?.wallet?.cashEligible.toLowerCase() === "true";
      this.rewardEligible = summary?.wallet?.rewardEligible.toLowerCase() === "true";
      this.defaultPayment = summary?.wallet?.defaultPaymentMethod.toLowerCase() === 'true';

      if (this.walletSummary?.wallet?.defaultPaymentMethod !== undefined) {
      //  console.log('Default Payment Method', this.walletSummary.wallet.defaultPaymentMethod);
      } else {
      //  console.log('Default Payment Method: undefined');
      }

       // NEW: Calculate combined rewards and cash for PPI display
      if (this.isPPI) {
        const totalRewardsVal = Number(this.walletSummary?.wallet?.rewards?.totalRewardBalance) || 0;
        const totalCashVal = Number(this.walletSummary?.wallet?.cash?.totalCashBalance) || 0;

        const rewardsThisMonth = Number(this.walletSummary?.wallet?.rewards?.rewardsEarnedThisMo) || 0;
        const cashThisMonth = Number(this.walletSummary?.wallet?.cash?.cashEarnedThisMo) || 0;

        this.totalRewards = totalRewardsVal.toFixed(2);
        this.totalCash = totalCashVal.toFixed(2);

        this.cashEarnedThisMonth = cashThisMonth.toFixed(2);
        this.rewardsEarnedThisMonth = rewardsThisMonth.toFixed(2);

        this.monthlyRewardsAndCash = (totalRewardsVal + totalCashVal).toFixed(2); // Format to 2 decimal places
      }
      if (this.isPPI) {
        const autoRedeemValue = this.walletSummary?.ppi?.wallet?.isDWAutoAutoRedeem;
        this.autoRedeem = autoRedeemValue?.toString().toLowerCase() === 'true';
        const ppiAutoPayStatus = this.walletSummary?.ppi?.wallet?.isDWAutoPay;
        // Convert 'True'/'False' string to the number 1 or 0 expected by the HTML template
        this.autoPay = (ppiAutoPayStatus?.toString().toLowerCase() === 'true') ? 1 : 0;
      }  else {
      this.autoPay = Number(this.walletSummary?.wallet.isDWAutoPay) || 0;
    }
      if (this.autoPay === 1 && this.walletSummary?.ppi?.wallet?.primaryAutoPay) {
        this.primaryAutoPayCard = this.walletSummary.ppi.wallet.primaryAutoPay;
      } else {
      this.primaryAutoPayCard = null;
      }
    });
    
    this.sessionService.isBilliant$.subscribe(val => {
      this.isBilliant = val;
      console.log("Header - Is Billiant:", this.isBilliant);
    });
  }

  // Example of “Set Default Payment” link
  setDefaultPayment() {
    this.router.navigate(['/preferences/manage-payment'], {
      queryParams: { from: 'set-default' }
    });
  }

  // Example of “Turn on Auto-Redeem” link

  turnOnAutoRedeem() {
    // Always navigate to auto-redeem, passing from=auto-redeem
    this.router.navigate(['/preferences/auto-redeem'], {
      queryParams: { from: 'auto-redeem' }
    });
  }

      turnOnAutoPay() {
    // Always navigate to auto-pay, passing from=auto-pay
    this.router.navigate(['/preferences/auto-pay'], {
      queryParams: { from: 'auto-pay' }
    });
  }


  getShortBankName(bankName: string): string {
    const bankNameMapping: { [key: string]: string } = {
      "JPMORGAN CHASE BANK, NATIONAL ASSOCIATION": "Chase",
      "JPMORGAN CHASE BANK, NA": "Chase",
    };
  
    // Return the mapped name if it exists, otherwise return the original name
    return bankNameMapping[bankName] || bankName;
  }

    getAutoTransferTypeLabel(type: string): string {
  if (!type) return '';
  const normalized = type.toLowerCase();
  if (normalized === 'rtp') return 'Instant';
  if (normalized === 'nonrtp' || normalized === 'non-rtp' || normalized === 'non_rtp' || normalized === 'non-rtp') return 'Regular';
  return '';
}
  

}
